import {
  Box,
  Step,
  StepLabel,
  Stepper,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Form, Formik, FormikHelpers, FormikValues } from "formik";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

// interface Props extends FormikConfig<FormikValues> {
// 	children: React.ReactNode;
// 	childRef: React.RefObject<HTMLFormElement>;
// }

interface IProps {
    children: any,
    initialValues: any,
    onSubmit: any,
    stepInit?: number,
}

const MultiStepForm = forwardRef((props: IProps, ref: any) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // useEffect(() => {
  // 	// console.log(isMobile);
  // }, [isMobile]);

  const handleStepInit = () => {
    if (stepInit !== undefined && !isNaN(stepInit)) return stepInit
    return 0;
  }

  const { children, initialValues, onSubmit, stepInit, ...rest } = props;
  const [stepNumber, setStepNumber] = useState(handleStepInit());
  const steps = React.Children.toArray(children) as React.ReactElement[];
  const [snapshot, setSnapshot] = useState(initialValues);
  const step = steps[stepNumber];
  const totalSteps = steps.length;
  const isLastStep = stepNumber === totalSteps - 1;
  const isOneBeforeLastStep = stepNumber === totalSteps - 2;

  const next = (values: FormikValues) => {
    // console.log(`next: ${values}`);
    setSnapshot(values);
    setStepNumber(stepNumber + 1);
  };

  const previous = (values: FormikValues) => {
    // console.log(`previous: ${values}`);

    setSnapshot(values);
    setStepNumber(stepNumber - 1);
  };

  const handleSubmit = async (
    values: FormikValues,
    actions: FormikHelpers<FormikValues>
  ) => {
    // if (step.props.onSubmit) {
    // 	// console.log(`step.props.onSubmit: ${step.props.onSubmit}`);
    // 	await step.props.onSubmit(values);
    // }

    if (isOneBeforeLastStep) {
      actions.setTouched({});

      // next(values);
      return onSubmit(values, actions);
    } else if (isLastStep) {
      // TODO : implement finish phase
    } else {
      actions.setTouched({});
      next(values);
    }
  };

  useImperativeHandle(ref, () => ({
    callPrevious() {
      previous(snapshot);
    },
  }));

  return (
    <Formik
      initialValues={snapshot}
      onSubmit={handleSubmit}
      validationSchema={step.props.validationSchema}
    >
      {(formik) => (
        <Box sx={{ my: "50px" }}>
          <Form>
            <Stepper
              activeStep={stepNumber}
              sx={{ px: { xs: "1rem", sm: "0rem" } }}
            >
              {steps.map((currentStep) => {
                const label = currentStep.props.stepName;
                if (label !== "") {
                  return (
                    <Step key={label}>
                      <StepLabel>{isMobile ? "" : label}</StepLabel>
                    </Step>
                  );
                }
                return "";
              })}
            </Stepper>

            {step}
            {/* <FormNavigation
							isLastStep={isLastStep}
							isOneBeforeLastStep={isOneBeforeLastStep}
							hasPrevious={stepNumber > 0}
							onBackClick={() => previous(formik.values)}
						></FormNavigation> */}
          </Form>
        </Box>
      )}
    </Formik>
  );
});

export default MultiStepForm;

export const FormStep = ({ stepName = "", children }: any) => children;
